/**
 * @author xiaohuangmaoth
 * @desc 参训统计管理
 * @date 2021-06-02
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool } from '@/tool'
import { templateConfig, reduxTemplateCofig } from './config'

const { WizContainer, WizReduxTemplate } = framework_tool;

class TrainingStatisticsManagement extends WizContainer {

  componentName = 'TrainingStatisticsManagement';

  
  _handleCmd(nextProps, nextState, key) {
    const res = nextProps[key]
    if (res['success']) {
      wizNotice.success(res['msg'])
      return true;
    } 
    wizNotice.error(res['msg'])
    return false;
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        updateTrainingStatistics: this._handleCmd,
        syncRecord: this._handleCmd,
        delete: this._handleCmd
      }
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(TrainingStatisticsManagement);
